<template>
    <div data-v-6ebeef4c>
        <usertop></usertop>
        <div data-v-bbc08a5e="" class="el-col el-col-24">
            <div data-v-bbc08a5e="" class="el-card is-never-shadow">
                <div class="el-card__body" style="padding: 16px; text-align: left;">
                    <div data-v-bbc08a5e="" class="G-title"><span data-v-bbc08a5e="">我的收藏</span></div>
                </div>
            </div>
            <div data-v-63c6a108="" data-v-bbc08a5e="">
                <div data-v-63c6a108="" class="el-row" style="z-index: 0;">
                    <div v-for="v in myfavorite"data-v-63c6a108="" class="el-col el-col-24 el-col-xs-24 el-col-sm-12 el-col-md-8 el-col-lg-8">
                        <a data-v-63c6a108="" :href="'show?id='+v.id" class="">
                            <div data-v-63c6a108="" class="el-card is-hover-shadow" style="margin: 0.1rem !important;">
                                <div class="el-card__body" style="padding: 0px; height: 160px;">
                                    <div data-v-63c6a108="" class="C-InfoCard">
                                        <div data-v-63c6a108="" class="Content">
                                            <div data-v-63c6a108="" class="Title">{{v.title}}</div>
                                            <div data-v-63c6a108="">
                                                <div data-v-63c6a108="" class="State">
                                                    <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108=""
                                                            aria-hidden="true" class="svg-icon"
                                                            style="fill: rgb(153, 153, 153);">
                                                            <use data-v-73b7ef61="" xlink:href="#icon-time"></use>
                                                        </svg> <span data-v-63c6a108="">{{v.create_time}}</span></div>
                                                    &nbsp;&nbsp;
                                                    <div data-v-63c6a108=""><svg data-v-73b7ef61="" data-v-63c6a108=""
                                                            aria-hidden="true" class="svg-icon"
                                                            style="fill: rgb(153, 153, 153);">
                                                            <use data-v-73b7ef61="" xlink:href="#icon-browse"></use>
                                                        </svg> <span data-v-63c6a108="">{{v.browse}}</span></div>
                                                </div>
                                                <div data-v-63c6a108="" class="Desc">{{v.process}}</div>
                                            </div>
                                            <div data-v-63c6a108="" class="Location">
                                                <div data-v-63c6a108="" class="Left"><svg data-v-73b7ef61=""
                                                        data-v-63c6a108="" aria-hidden="true" class="svg-icon"
                                                        style="fill: rgb(255, 51, 153);">
                                                        <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
                                                    </svg> <span data-v-63c6a108="">{{v.dz}}</span></div>
                                                <div data-v-63c6a108="" class="Tags"> </div>
                                            </div>
                                        </div> <img data-v-63c6a108="" alt="img" :src="v.img" onerror="this.remove()" class="Cover">
                                    </div>
                                </div>
                            </div>
                        </a></div>
                </div>
                <div data-v-63c6a108="">
                    <div data-v-63c6a108="" class="el-card is-never-shadow" style="margin: 0px;">
                        <div class="el-card__body" style="margin: 20px;">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            :pager-count="5"
                            @current-change="pageclick"
                            :page-size="24"
                            :current-page=currentpage
                            >
                        </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'myfavorite',
    data() {
        return {
            
            myfavorite:[],
            total:0,
            currentpage:1,

        }
    },
    methods:{
        pageclick(pp){

        }
    },
    mounted() {

        this.$http.post('/api/shoucang',{type:1}).then(res=>{

            this.myfavorite = res.data.data
            
            this.total = res.data.count
        })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/myfavorite.vue